<template>
    <form-accordion
        name="home-office"
        section="Home Office Contacts"
        :url="url"
        method="patch"
        :closed="closed"
        :collapsible="accordion"
        :include_discard_button="include_discard_button"
>

        <office-manager
            :contact="contacts_office_manager"
        />

        <home-office-coordinator
            :contact="contacts_home_office_coordinator"
        />

        <managing-broker
            :contact="contacts_managing_broker"
        />

        <transaction-coordinator
            :contact="contacts_transaction_coordinator"
        />
    </form-accordion>
</template>

<script>
import ManagingBroker from './managing-broker.vue';
import OfficeManager from './office-manager.vue';
import TransactionCoordinator from './transaction-coordinator.vue';
import HomeOfficeCoordinator from './home-office-coordinator.vue';

export default {
    components: {
        ManagingBroker,
        OfficeManager,
        TransactionCoordinator,
        HomeOfficeCoordinator,
    },

    props: {
        closed: { default: true },
        url: {},
        broker: {},
        settings: {},
        contacts_home_office_coordinator: {},
        contacts_managing_broker: {},
        contacts_office_manager: {},
        contacts_transaction_coordinator: {},
        accordion: { default: true },
        include_discard_button: { default: true },
    },
}
</script>
